import React from "react";
import { storyblokEditable, renderRichText } from "gatsby-source-storyblok";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { Href } from "../utils/helper";

const Carousel = ({blok}) => {
  const settings = {
    autoplay: blok.autoplay,
    fade: blok.animationType === 'fade' ? true : false,
    infinite: true,
    dots: false,
    arrows: false,
    autoplaySpeed: 10000,
    slidesToShow: 1,
    slidesToScroll: 1,
    waitForAnimate: false
  };

  const positionClass = {
    left: 'sm:top-1/2 left-0 lg:left-[5%] xl:left-[10%] sm:-translate-y-1/2',
    center: 'sm:top-1/2 left-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2',
    right: 'sm:-top-1/2 right-0 lg:right-[5%] xl:right-[10%] sm:translate-y-1/2',
  };

  const sliderItem = (blok) => (
    <div key={blok._uid} className="relative w-full text-white text-left" {...storyblokEditable(blok)}>
      
      <img loading="lazy" src={blok.baseImageMobile?.filename ? `${blok.baseImageMobile?.filename}/m/` : `${blok.baseImageDesktop?.filename}/m/`} alt={blok.baseImageMobile.alt} className="w-full h-[400px] md:h-0 object-cover object-bottom"/>
      <img loading="lazy" src={`${blok.baseImageDesktop?.filename}/m/`} alt={blok.baseImageDesktop.alt} className="w-full h-0 md:h-[600px] object-cover"/>
  
      <div className={`max-w-7xl h-full relative sm:absolute ${positionClass[blok.position]}`}>
        <div style={{backgroundColor: blok.bgColor.color}} className="md:max-w-xl max-h-xl h-[400px] md:h-full p-10 md:p-14 pr-5">
          <div className="flex justify-end relative">
            {blok.speechBubble?.filename && 
            <img loading="lazy" src={blok.speechBubble?.filename} alt={blok.speechBubble?.alt} className="w-[350px] absolute top-[-130px] md:relative md:top-0"/>
            }
          </div>
          <div className="flex align-end mb-4">
            <img loading="lazy" src={blok.icon} alt="icon" className="block mr-3"/>
            <p className="border-b-2">{blok.subHeading}</p>
          </div>
          <h2 className="text-xl md:text-4xl mb-8 !leading-relaxed font-serif">{blok.tagLine}</h2>
          
          <div className="text-xl leading-relaxed" dangerouslySetInnerHTML={{__html: renderRichText(blok.description)}} />
          
          <a href={Href(blok.ctaUrl)} className="flex items-baseline text-lg border-2 rounded-xl py-2 px-8 mt-6 xl:mt-8 w-fit">
            <div>{blok.ctaText}</div>
            <img className="w-[36px] h-[13px] ml-4" src="/icons/newsletter-cta-arrow-right.svg" alt="Arrow right"/>
          </a>
        </div>
      </div>
    </div>
  )
  
  return (
    <div className="slider-container" {...storyblokEditable(blok)}>
      <Slider {...settings}>{blok.carouselItems.map(blok => (sliderItem(blok)))}</Slider>
    </div>
  );
};
  
export default Carousel
